import { __decorate, __metadata } from "tslib";
import { IsUndefinable, LengthWithLVS } from '@goparrot/common';
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import { IsDefined, IsNotEmpty, IsOptional, IsString, ValidateNested } from 'class-validator';
import { WebStoreExposeGroup } from '../interface';
import { ReadWebStoreComponentsDto } from './ReadWebStoreComponentsDto';
import { ReadWebStoreMetadataDto } from './ReadWebStoreMetadataDto';
export class ReadWebStoreDto {
}
__decorate([
    ApiProperty({ type: () => String, description: 'ref to merchant.merchantId', example: 'ddfb5654-7fe1-40de-8be8-041116c8f267' }),
    Expose({ groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    __metadata("design:type", String)
], ReadWebStoreDto.prototype, "merchantId", void 0);
__decorate([
    ApiProperty({ type: () => String, description: 'ref to store.storeId', example: 'd67896f6-b084-4a4e-9e74-7ba4127fc8b0' }),
    Expose({ groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    __metadata("design:type", String)
], ReadWebStoreDto.prototype, "storeId", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    IsString({ always: true }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreDto.prototype, "hostname", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    LengthWithLVS(1, 255, { always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    __metadata("design:type", String)
], ReadWebStoreDto.prototype, "storeName", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    LengthWithLVS(1, 255, { always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    __metadata("design:type", String)
], ReadWebStoreDto.prototype, "storeUrl", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    IsString({ always: true }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebStoreDto.prototype, "title", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    LengthWithLVS(1, 255, { always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    __metadata("design:type", String)
], ReadWebStoreDto.prototype, "storeTitle", void 0);
__decorate([
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsDefined({ groups: [WebStoreExposeGroup.UPDATE] }),
    ValidateNested({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    Type(() => ReadWebStoreMetadataDto),
    __metadata("design:type", ReadWebStoreMetadataDto)
], ReadWebStoreDto.prototype, "metadata", void 0);
__decorate([
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsDefined({ groups: [WebStoreExposeGroup.UPDATE] }),
    ValidateNested({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    Type(() => ReadWebStoreComponentsDto),
    __metadata("design:type", ReadWebStoreComponentsDto)
], ReadWebStoreDto.prototype, "components", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Object }),
    Expose({ groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE] }),
    IsDefined({ groups: [WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE] }),
    __metadata("design:type", Object)
], ReadWebStoreDto.prototype, "theme", void 0);
//# sourceMappingURL=ReadWebStoreDto.js.map